module.exports = __webpack_public_path__ + "img/wallet-balance.064202b6.svg";